const STORAGE_KEY = 'whitelabel_auth';

/**
 * Clear stale bearer tokens from localStorage.
 * Called once on app startup to clean up tokens from the old OAuth-based auth flow.
 */
export function clearToken() {
    localStorage.removeItem(STORAGE_KEY);
}

/**
 * Generate a one-time exchange code for cross-domain auth.
 * Used when navigating between domains (custom ↔ main, custom ↔ custom).
 */
export async function createExchangeCode() {
    const response = await axios.post('/api/auth/exchange-code');
    return response.data.code;
}

/**
 * Set up axios interceptor.
 * No bearer token logic needed — Passport JWT cookie (set by CreateFreshApiToken)
 * handles auth automatically on all domains. The browser sends the cookie with every request.
 */
export function setupAxiosInterceptor() {
    // Passport JWT cookie + CSRF token handle auth on all domains.
    // No request interceptor needed — cookies are sent automatically by the browser.
    // No response interceptor for token refresh — session expiry is handled by the router guard.
}
